(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-rr-product]:not([data-rr-ready])').forEach((root) => {
      root.dataset.rrReady = 'true';

      const mainImage = root.querySelector('[data-rr-main-image]');
      root.querySelectorAll('[data-rr-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!mainImage || !thumb.dataset.src) return;
          mainImage.src = thumb.dataset.src;
          root.querySelectorAll('[data-rr-thumb]').forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      const form = root.querySelector('[data-rr-form]');
      const variantInput = root.querySelector('[data-rr-variant-input]');
      const buyButton = root.querySelector('[data-rr-buy]');
      const buyText = root.querySelector('[data-rr-buy-text]');
      const status = root.querySelector('[data-rr-status]');
      const price = root.querySelector('[data-rr-price]');
      const compare = root.querySelector('[data-rr-compare]');
      const off = root.querySelector('[data-rr-off]');
      const readyBundles = root.querySelectorAll('[data-rr-bundle]:not(:disabled)').length;

      root.querySelectorAll('[data-rr-bundle]').forEach((radio) => {
        radio.addEventListener('change', () => {
          if (!radio.checked || !radio.value) return;
          root.querySelectorAll('.rr-discount-item').forEach((item) => item.classList.remove('is-active'));
          radio.closest('.rr-discount-item')?.classList.add('is-active');
          if (variantInput) variantInput.value = radio.value;
          if (price) price.textContent = radio.dataset.price || '';
          if (compare) compare.textContent = radio.dataset.compare || '';
          if (off) off.textContent = radio.dataset.off || '';
          const available = radio.dataset.available === 'true';
          if (buyButton) buyButton.disabled = readyBundles < 4 || !available;
          if (buyText) buyText.textContent = available ? 'Buy Now' : 'Sold Out';
        });
      });

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!variantInput?.value || buyButton?.disabled) return;
        buyButton.disabled = true;
        if (buyText) buyText.textContent = 'Adding…';
        if (status) status.textContent = '';
        try {
          const rootPath = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: 1 }] }),
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || 'This bundle could not be added.');
          if (buyText) buyText.textContent = 'Added';
          if (status) status.textContent = 'Redirecting to secure checkout…';
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: payload }));
          window.setTimeout(() => { window.location.href = `${rootPath}checkout`; }, 450);
        } catch (error) {
          if (status) status.textContent = error instanceof Error ? error.message : 'Please try again.';
          if (buyText) buyText.textContent = 'Buy Now';
          buyButton.disabled = false;
        }
      });

      root.querySelectorAll('[data-rr-scroll]').forEach((button) => {
        button.addEventListener('click', () => root.querySelector('#rr-bundles')?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
